import './App.css';

import { lazy, Suspense } from 'react';

import PageSuspenseFallback from './components/PageSuspenseFallback/PageSuspenseFallback';
import ChangePass from './pages/ChangePass/ChangePass';

import MainPage from './pages/Main_page/MainPage';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';

import SalaryPage from './pages/SalaryPage/SalaryPage';
import VacationRequestEmp from './pages/VacationRequest/VacationRequestEmp/VacationRequestEmp';

import EvaluationForEmployeeShowPage from './pages/EvaluationForEmployeeShowPage/EvaluationForEmployeeShowPage';


import Login from './pages/Login/Login';
import CheckPrivateRouteAuth from './components/CheckPrivateRouteAuth/CheckPrivateRouteAuth';
import MainLayout from './Layouts/MainLayout';

import PermissionWrapper from './checkPermissionsForPages';
import IsManagerWrapper from './checkIfUserIsManager';
import Unautherized from './pages/Unautherized/Unautherized';

import IsManagerOrHasPermissionWrapper from './checkIfUserIsManagerOrHasPermission';
import EvalDirectManagerByEmps from './pages/EvaluationManagmentAllPagesRelated/EvalDirectManagerPages/EvalDirectManagerByEmps/EvalDirectManagerByEmps';
const EvalDirectManagerStat = lazy(() => import('./pages/EvaluationManagmentAllPagesRelated/EvalDirectManagerPages/EvalDirectManagerStat/EvalDirectManagerStat'));
const EmpArchives = lazy(() => import('./pages/EmpArchives/MainEmpArchives/EmpArchives'));
const ManageRoles = lazy(() => import('./pages/ManageRoles/ManageRoles'));
const ManagmentPunshmentsByHRs = lazy(() => import('./pages/ManagmentPunshmentsByHRs/ManagmentPunshmentsByHRs'));
const UpdateAnOldJobPosition = lazy(() => import('./pages/MangeJobPositionsAllRelatedPages/UpdateAnOldJobPosition/UpdateAnOldJobPosition'));
const CreateNewJobPosition = lazy(() => import('./pages/MangeJobPositionsAllRelatedPages/CreateNewJobPosition/CreateNewJobPosition'));
const MangmentJobPositions = lazy(() => import('./pages/MangeJobPositionsAllRelatedPages/MangmentJobPositions/MangmentJobPositions'));
const CreateNewDepartment = lazy(() => import('./pages/MangeDepartmentsAllPagesRelated/CreateNewDepartment/CreateNewDepartment'));
const UpdateAnOldDepatment = lazy(() => import('./pages/MangeDepartmentsAllPagesRelated/UpdateAnOldDepartment/UpdateAnOldDepatment'));
const ManagmentDepartments = lazy(() => import('./pages/MangeDepartmentsAllPagesRelated/ManagementDepartments/ManagmentDepartments'));
const VacationStatistics = lazy(() => import('./pages/VacationStatistics/VacationStatistics'));
const VacationManagerShow = lazy(() => import('./pages/VacationManagerShow/VacationManagerShow'));
const UploadFiles = lazy(() => import('./pages/UploadFiles/UploadFiles'));
const EmpsMangment = lazy(() => import('./pages/EmpsMangment/EmpsMangment'));
const DepartmentEmps = lazy(() => import('./pages/DepartmentEmps/DepartmentEmps'));
const VacationHRShow = lazy(() => import('./pages/VacationHRShow/VacationHRShow'));
const EmpsForADepartmnet = lazy(() => import('./pages/MangeDepartmentsAllPagesRelated/EmpsForADepartmnet/EmpsForADepartmnet'));
const VacationRequestEmpByManager = lazy(() => import('./pages/VacationRequest/VacationRequestEmpByManager/VacationRequestEmpByManager'));
const ExitPermissionsGuardsPage = lazy(() => import('./pages/ExitPermissionsPages/ExitPermissionsGuardsPage/ExitPermissionsGuardsPage'));
const ExitPermissionStatistics = lazy(() => import("./pages/ExitPermissionsPages/ExitPermissionStatistics/ExitPermissionStatistics"));
const EvaluationStartForTestPeriodEmps = lazy(() => import('./pages/EvaluationManagmentAllPagesRelated/EvaluationStartForTestPeriodEmps/EvaluationStartForTestPeriodEmps'));
const EvaluationRequestsWatingforHRManager = lazy(() => import('./pages/EvaluationManagmentAllPagesRelated/EvaluationManageStatistics/EvaluationRequestsWatingforHRManager/EvaluationRequestsWatingforHRManager'));
const EvaluationSettingsManagment = lazy(() => import('./pages/EvaluationSettingsManagment/EvaluationSettingsManagment'));
const EvaluationDraftMainComp = lazy(() => import('./pages/EvaluationManagmentAllPagesRelated/EvaluationManagmentDraftsPages/EvaluationDraftMainComp/EvaluationDraftMainComp'));
const EvaluationRequestsReturnedBackToTheEvaluationofficer = lazy(() => import('./pages/EvaluationManagmentAllPagesRelated/EvaluationManageStatistics/EvaluationRequestsReturnedBackToTheEvaluationofficer/EvaluationRequestsReturnedBackToTheEvaluationofficer'));
const EvaluationRequestsReturnedBackToTheManagersDep = lazy(() => import('./pages/EvaluationManagmentAllPagesRelated/EvaluationManageStatistics/EvaluationRequestsReturnedBackToTheManagersDep/EvaluationRequestsReturnedBackToTheManagersDep'));
const EvaluationRequestsWatingTheManagersDep = lazy(() => import('./pages/EvaluationManagmentAllPagesRelated/EvaluationManageStatistics/EvaluationRequestsWatingTheManagersDep/EvaluationRequestsWatingTheManagersDep'));
const EmpsWhoHaveBeenEvaluatedPage = lazy(() => import('./pages/EvaluationManagmentAllPagesRelated/EvaluationManageStatistics/EmpsWhoHaveBeenEvaluatedPage/EmpsWhoHaveBeenEvaluatedPage'));
const EvaluationStatisticsMainPageShow = lazy(() => import('./pages/EvaluationManagmentAllPagesRelated/EvaluationManageStatistics/EvaluationStatisticsMainPageShow/EvaluationStatisticsMainPageShow'));
const EvaluationRequestsWatingforEvaluationofficer = lazy(() => import('./pages/EvaluationManagmentAllPagesRelated/EvaluationManageStatistics/EvaluationRequestsWatingforEvaluationofficer/EvaluationRequestsWatingforEvaluationofficer'));
const EvaluationEmpFromManager = lazy(() => import('./pages/EvaluationManagmentAllPagesRelated/EvaluationEmpFromManagerPages/EvaluationEmpFromManager/EvaluationEmpFromManager'));
const CreateNewCompanyInternalNum = lazy(() => import('./pages/CompPhoneNumsManagment/CompInternalNumsComponents/CreateNewCompanyInternalNum/CreateNewCompanyInternalNum'));
const ChangeCompanyInternalNum = lazy(() => import('./pages/CompPhoneNumsManagment/CompInternalNumsComponents/ChangeCompanyInternalNum/ChangeCompanyInternalNum'));
const CompInternalNums = lazy(() => import('./pages/CompPhoneNumsManagment/CompInternalNumsComponents/CompInternalNums/CompInternalNums'));
const CreateNewUser = lazy(() => import('./pages/CreateNewUser/CreateNewUser'));
const AddNewPunshment = lazy(() => import('./components/PunshmentsComps/AddNewPunshment/AddNewPunshment'));
const NoficationsPage = lazy(() => import('./pages/NoficationsPage/NoficationsPage'));

const EmpPageShowHealthInusuranceInfo = lazy(() => import('./pages/HealthInsurancePages/EmpPageShowHealthInusuranceInfo/EmpPageShowHealthInusuranceInfo'));
const AddHealthInsuranceDataByEmp = lazy(() => import('./pages/HealthInsurancePages/ChangeHealthInsuranceDataByEmp/AddHealthInsuranceDataByEmp/AddHealthInsuranceDataByEmp'));
const UpdateHealthInsuranceDataByEmp = lazy(() => import('./pages/HealthInsurancePages/ChangeHealthInsuranceDataByEmp/UpdateHealthInsuranceDataByEmp/UpdateHealthInsuranceDataByEmp'));
const HealthInsuranceCard = lazy(() => import('./components/HealthInsuranceComps/HeathInsuranceHRComps/HealthInsuranceCard/HealthInsuranceCard'));
const HealthInsuranceManageRelativesData = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManageRelativesData/HealthInsuranceManageRelativesData'));

const HealthInsuranceProcedMain = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/HealthInsuranceProceduresPages/HealthInsuranceProcedMain/HealthInsuranceProcedMain'));
const HealthInsuranceProcedAdd = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/HealthInsuranceProceduresPages/HealthInsuranceProcedAdd/HealthInsuranceProcedAdd'));
const HealthInsuranceProcedUpdate = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/HealthInsuranceProceduresPages/HealthInsuranceProcedUpdate/HealthInsuranceProcedUpdate'));

const HealthInsuranceLeafProcedMain = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/HealthInsuranceLeafProceduresPages/HealthInsuranceLeafProcedMain/HealthInsuranceLeafProcedMain'));
const HealthInsuranceLeafProcedAdd = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/HealthInsuranceLeafProceduresPages/HealthInsuranceLeafProcedAdd/HealthInsuranceLeafProcedAdd'));
const HealthInsuranceLeafProcedUpdate = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/HealthInsuranceLeafProceduresPages/HealthInsuranceLeafProcedUpdate/HealthInsuranceLeafProcedUpdate'));

const HealthInsuranceCateMain = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/HealthInsuranceCatePages/HealthInsuranceCateMain/HealthInsuranceCateMain'));
const HealthInsuranceCateAdd = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/HealthInsuranceCatePages/HealthInsuranceCateAdd/HealthInsuranceCateAdd'));
const HealthInsuranceCateUpdate = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/HealthInsuranceCatePages/HealthInsuranceCateUpdate/HealthInsuranceCateUpdate'));

const HealthInsuranceMdCenterUpdate = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/HealthInsuranceMedicalCenterPages/HealthInsuranceMdCenterUpdate/HealthInsuranceMdCenterUpdate'));
const HealthInsuranceMdCenterAdd = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/HealthInsuranceMedicalCenterPages/HealthInsuranceMdCenterAdd/HealthInsuranceMdCenterAdd'));
const HealthInsuranceMdCenterMain = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/HealthInsuranceMedicalCenterPages/HealthInsuranceMdCenterMain/HealthInsuranceMdCenterMain'));


const HealthInsuranceManagmentMain = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/HealthInsuranceManagmentMain/HealthInsuranceManagmentMain'));
const MainPagePunshments = lazy(() => import('./pages/ManagmentPunshments/MainPagePunshments/MainPagePunshments.jsx'));
const ConnectCateWithProcedUpdate = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/ConnectCateWithProcedPages/ConnectCateWithProcedUpdate/ConnectCateWithProcedUpdate'));
const ConnectCateWithProcedMain = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/ConnectCateWithProcedPages/ConnectCateWithProcedMain/ConnectCateWithProcedMain'));
const ConnectCateWithProcedAdd = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/ConnectCateWithProcedPages/ConnectCateWithProcedAdd/ConnectCateWithProcedAdd'));

const HealthInsuranceBillsUpdate = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/HealthInsuranceBillsPages/HealthInsuranceBillsUpdate/HealthInsuranceBillsUpdate'));
const HealthInsuranceBillsMain = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/HealthInsuranceBillsPages/HealthInsuranceBillsMain/HealthInsuranceBillsMain'));
const HealthInsuranceBillsAdd = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/HealthInsuranceBillsPages/HealthInsuranceBillsAdd/HealthInsuranceBillsAdd'));
const AdvanceManagement = lazy(() => import('./pages/HealthInsurancePages/AdvancePages/AdvanceManagement'));
const FactoriesManagement = lazy(() => import('./pages/FactoriesManagement/FactoriesManagement'));
const PenaltyManagment = lazy(() => import('./pages/PenaltyManagment/PenaltyManagment'));
const ViolationManagement = lazy(() => import('./pages/ViolationManagement/ViolationManagement'));
const WorkSchedule = lazy(() => import('./pages/WorkSchedule/WorkSchedule'));
const DisciplinaryCases = lazy(() => import('./pages/DisciplinaryCases/DisciplinaryCases'));
const HealthInsuranceStatementsMain = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/HealthInsuranceStatementsPages/HealthInsuranceStatementsMain/HealthInsuranceStatementsMain'));
const EditStatmentPerson = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/HealthInsuranceStatementsPages/EditStatmentPersonPages/EditStatmentPerson.jsx'));

const HealthInsuranceStatementShow = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/HealthInsuranceStatementsPages/HealthInsuranceStatementShow/HealthInsuranceStatementShow'));
const WhateInsurance = lazy(() => import('./pages/HealthInsurancePages/whateInsurance/whateInsurance/WhateInsurance'));
const AddWhateInsurance = lazy(() => import('./pages/HealthInsurancePages/whateInsurance/addWhateInsurance/AddWhateInsurance'));
const HealthIncMnainStat = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceManagmentPages/HealthIncuranceStatPages/HealthIncMnainStat/HealthIncMnainStat'));
const HealthInsuranceCategoryPerson = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceCategoryPersonPages/HealthInsuranceCategoryPerson.jsx'));
const HealthInsuranceVisitHistory = lazy(() => import('./pages/HealthInsurancePages/HealthInsuranceVisitHistory/HealthInsuranceVisitHistory'));

const InsuranceInformation = lazy(() => import('./pages/HealthInsurancePages/InsuranceInformation/InsuranceInformation.jsx'));
const EmpsMangmentForQr = lazy(() => import('./pages/EmpsMangmentForQr/EmpsMangmentForQr'));


const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/emp" />
  },
  {
    path: '/emp',
    element: (
      <CheckPrivateRouteAuth>
        <MainLayout />
      </CheckPrivateRouteAuth>
    ),
    //   errorElement: <Error />,
    children: [
      {
        index: true,
        element: (
          <CheckPrivateRouteAuth>
            <MainPage />
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'empmang',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['read_users']}>
              <PageSuspenseFallback>
                <EmpsMangment />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'change_pass',
        element: (
          <CheckPrivateRouteAuth>
            <ChangePass />
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'uploadfiles',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['import_salaries', 'update_users', 'update_job_positions', 'update_papers', 'update_insurances', 'update_departments', 'update_relatives']}>
              <PageSuspenseFallback>
                <UploadFiles />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'archives_show',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['delete_users']}>
              <PageSuspenseFallback>
                <EmpArchives />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'vacations_hr_show',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['change_vacation_status']}>
              <PageSuspenseFallback >
                <VacationHRShow />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'departmentemps',
        element: (
          <CheckPrivateRouteAuth>
            <IsManagerWrapper>
              <PageSuspenseFallback>
                <DepartmentEmps />
              </PageSuspenseFallback>
            </IsManagerWrapper>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'salarypage',
        element: (
          <CheckPrivateRouteAuth>
            <SalaryPage />
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'whate_insurance',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <WhateInsurance />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>
        ),
      }
      ,
      {
        path: 'vacationreq',
        element: (
          <CheckPrivateRouteAuth>
            <VacationRequestEmp />
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'vaca_req_by_manager',
        element: (
          <CheckPrivateRouteAuth>
            <IsManagerWrapper>
              <PageSuspenseFallback>
                <VacationRequestEmpByManager />
              </PageSuspenseFallback>
            </IsManagerWrapper>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'vacationmang',
        element: (
          <CheckPrivateRouteAuth>
            <IsManagerWrapper>
              <PageSuspenseFallback>
                <VacationManagerShow />
              </PageSuspenseFallback>
            </IsManagerWrapper>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'vaca_stat',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['read_vacation_statistics']}>
              <PageSuspenseFallback>
                <VacationStatistics />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'exist_per_stat',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['read_vacation_statistics']}>
              <PageSuspenseFallback>
                <ExitPermissionStatistics />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'exist_per_guards',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['door_officer']}>
              <PageSuspenseFallback>
                <ExitPermissionsGuardsPage />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'eval_emp',
        element: (
          <CheckPrivateRouteAuth>
            <EvaluationForEmployeeShowPage />
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'eval_manager_by_emp',
        element: (
          <CheckPrivateRouteAuth>
            {/* <PageSuspenseFallback></PageSuspenseFallback> */}
            <EvalDirectManagerByEmps />
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'eval_directManager_stat',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['read_evaluation_manager_statistics']}>
              <PageSuspenseFallback>
                <EvalDirectManagerStat />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'mang_deps',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['read_departments']}>
              <PageSuspenseFallback>
                <ManagmentDepartments />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'create_dep',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['create_departments']}>
              <PageSuspenseFallback>
                <CreateNewDepartment />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'update_dep/:id',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['update_departments']}>
              <PageSuspenseFallback>
                <UpdateAnOldDepatment />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'show_emps_dep/:id',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['read_departments']}>
              <PageSuspenseFallback>
                <EmpsForADepartmnet />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'mang_job_positions',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['read_job_positions']}>
              <PageSuspenseFallback>
                <MangmentJobPositions />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'create_job_position',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['create_job_positions']}>
              <PageSuspenseFallback>
                <CreateNewJobPosition />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'update_job_position/:id',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['update_job_positions']}>
              <PageSuspenseFallback>
                <UpdateAnOldJobPosition />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'nofications',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <NoficationsPage />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'manage_roles',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['read_roles']}>
              <PageSuspenseFallback>
                <ManageRoles />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'punshments_hr',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['read_penalties']}>
              <PageSuspenseFallback>
                <ManagmentPunshmentsByHRs />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>
        )
      },

      {
        path: 'punshments',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['read_penalties']}>
              <PageSuspenseFallback>
                <MainPagePunshments />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>
        )
      },

      {
        path: 'addPunshment',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['create_penalties']}>
              <PageSuspenseFallback >
                <AddNewPunshment />
              </PageSuspenseFallback >
            </PermissionWrapper>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'addNewUser',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['create_users']}>
              <PageSuspenseFallback>
                <CreateNewUser />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>
        )
      },
      ,
      {
        path: 'compInternalNums',
        element: (
          // <CheckPrivateRouteAuth>
          // <PermissionWrapper requiredPermissions={['read_penalties']}>
          <PageSuspenseFallback>
            <CompInternalNums />
          </PageSuspenseFallback>
          //   </PermissionWrapper>
          // </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'create_internalNum',
        element: (
          // <CheckPrivateRouteAuth>
          // <PermissionWrapper requiredPermissions={['read_penalties']}>
          <PageSuspenseFallback>
            <CreateNewCompanyInternalNum />
          </PageSuspenseFallback>
          //   </PermissionWrapper>
          // </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'update_interalNum/:id',
        element: (
          // <CheckPrivateRouteAuth>
          // <PermissionWrapper requiredPermissions={['update_job_positions']}>
          <ChangeCompanyInternalNum />
          //   </PermissionWrapper>
          // </CheckPrivateRouteAuth> 
        )
      },
      {
        path: 'eval_emp_manager',
        element: (
          <CheckPrivateRouteAuth>
            <IsManagerOrHasPermissionWrapper requiredPermissions={['hr_manager', 'read_evaluations', 'update_evaluations']}>
              <PageSuspenseFallback>
                <EvaluationEmpFromManager />
              </PageSuspenseFallback>
            </IsManagerOrHasPermissionWrapper>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'eval_emp_draft',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <EvaluationDraftMainComp />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'eval_stat_main_page_show',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['read_evaluation_statistics']}>
              <PageSuspenseFallback>
                <EvaluationStatisticsMainPageShow />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>

        )
      },

      {
        path: 'eval_stat_evalOfficer',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['read_evaluation_statistics']}>
              <PageSuspenseFallback>
                <EvaluationRequestsWatingforEvaluationofficer />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'eval_stat_evalOfficer_returnedBack',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['read_evaluation_statistics']}>
              <PageSuspenseFallback>
                <EvaluationRequestsReturnedBackToTheEvaluationofficer />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'eval_stat_emps_evaluated_before',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['read_evaluation_statistics']}>
              <PageSuspenseFallback>
                <EmpsWhoHaveBeenEvaluatedPage />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'eval_stat_requests4manger',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['read_evaluation_statistics']}>
              <PageSuspenseFallback>
                <EvaluationRequestsWatingTheManagersDep />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'eval_stat_requests4manger_returnedBack',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['read_evaluation_statistics']}>
              <PageSuspenseFallback>
                <EvaluationRequestsReturnedBackToTheManagersDep />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'eval_stat_requests4HRmanager',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['read_evaluation_statistics']}>
              <PageSuspenseFallback>
                <EvaluationRequestsWatingforHRManager />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'eval_settings',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['read_evaluation_settings']}>
              <PageSuspenseFallback>
                <EvaluationSettingsManagment />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'eval_start_testperiod_requests',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['create_evaluations']}>
              <PageSuspenseFallback>
                <EvaluationStartForTestPeriodEmps />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_personal_data',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <InsuranceInformation />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'shwo_insurance_info',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <EmpPageShowHealthInusuranceInfo />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_personal_add_by_emp',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <AddHealthInsuranceDataByEmp />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_personal_update_by_emp',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <UpdateHealthInsuranceDataByEmp />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_patient_visit_history',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <HealthInsuranceVisitHistory />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_card',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['read_relatives']}>
              <PageSuspenseFallback>
                <HealthInsuranceCard />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>

        )
      }
      ,
      {
        path: 'h_insurance_manage_relatives_data',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['read_relatives', 'update_relatives', 'delete_relatives']}>
              <PageSuspenseFallback>
                <HealthInsuranceManageRelativesData />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_managment_main_page',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <HealthInsuranceManagmentMain />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_manage_categories',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <HealthInsuranceCateMain />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_add_categories',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <HealthInsuranceCateAdd />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_update_categories',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <HealthInsuranceCateUpdate />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_manage_procedures',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <HealthInsuranceProcedMain />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_add_procedures',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <HealthInsuranceProcedAdd />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_update_procedures',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <HealthInsuranceProcedUpdate />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_manage_leaf_procedures',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <HealthInsuranceLeafProcedMain />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_add_leaf_procedures',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <HealthInsuranceLeafProcedAdd />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_update_leaf_procedures',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <HealthInsuranceLeafProcedUpdate />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_manage_medical_centers',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <HealthInsuranceMdCenterMain />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_add_medical_center',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <HealthInsuranceMdCenterAdd />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_update_medical_center',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <HealthInsuranceMdCenterUpdate />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_manage_proced_cate_connection',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <ConnectCateWithProcedMain />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_add_proced_cate_connection',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <ConnectCateWithProcedAdd />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_update_proced_cate_connection',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <ConnectCateWithProcedUpdate />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_add_bills',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['create_health_insurance_bills']}>
              <PageSuspenseFallback>
                <HealthInsuranceBillsAdd />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_manage_bills',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['read_health_insurance_bills', 'update_health_insurance_bills']}>
              <PageSuspenseFallback>
                <HealthInsuranceBillsMain />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_update_bills',
        element: (
          <CheckPrivateRouteAuth>
            <PermissionWrapper requiredPermissions={['update_health_insurance_bills']}>
              <PageSuspenseFallback>
                <HealthInsuranceBillsUpdate />
              </PageSuspenseFallback>
            </PermissionWrapper>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_manage_statements',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <HealthInsuranceStatementsMain />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'edit_statment_person',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <EditStatmentPerson />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'advance_management',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <AdvanceManagement />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>
        )
      },
       {
        path: 'factories',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <FactoriesManagement />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>
        )
      },
       {
        path: 'penalty-types',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <PenaltyManagment />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'violations',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <ViolationManagement />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'work-schedules',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <WorkSchedule />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>
        )
      },
        {
        path: 'disciplinary_cases',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <DisciplinaryCases />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'h_insurance_show_statement',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <HealthInsuranceStatementShow />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>
        )
      },
      {
        path: 'h_insurance_show_emp_data/:id',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <EmpsMangmentForQr />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>

        )
      },
      {
        path: 'h_insurance_main_stat',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <HealthIncMnainStat />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>
        )
      }
      ,
      {
        path: 'show_info_person_category',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <HealthInsuranceCategoryPerson />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>
        )
      }
      ,
      {
        path: 'add_whate_insurance',
        element: (
          <CheckPrivateRouteAuth>
            <PageSuspenseFallback>
              <AddWhateInsurance />
            </PageSuspenseFallback>
          </CheckPrivateRouteAuth>
        )
      }

    ]
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/not_authorized',
    element: <Unautherized /> // Or a proper "Not Authorized" component
  }
  ,

  // {
  //   path: '/register',
  //   element: <Register />
  // }
]);




function App() {

  return (
    <div className="App">

      <RouterProvider router={router} />

    </div>
  );

}

export default App;
